<template>
  <hm-content title="项目列表">
    <div slot="header">
      <hm-step :steps="steps" :step="3"></hm-step>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddService"
          >新增项目</el-button
        >
      </div>
      <div>
        <el-select
          clearable
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in storeList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="serviceCategoryId"
          placeholder="选择服务分类"
          size="small"
          filterable
          :disabled="!storeOutletId"
          class="mr10"
        >
          <el-option
            v-for="item in serviceCategoryList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <el-select clearable
                   v-model="chargeType"
                   placeholder="计费方式"
                   size="small"
                   filterable
                   class="mr10">
          <el-option label="按次计费"
                     :value="0"></el-option>
          <el-option label="按时计费"
                     :value="1"></el-option>
        </el-select>-->
        <el-input
          clearable
          v-model.trim="name"
          placeholder="输入项目名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          placeholder="输入名称"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="serviceList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          width="50"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="说明"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverTag"
          label="标签"
        >
          <template slot-scope="scope">
            <span class="tag" v-for="(v, i) in scope.row.serverTags" :key="i">{{
              v
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column header-align="center" align="center" prop="serverTag" label="有效期">
          <template slot-scope="scope">
            <span v-if="scope.row.validateType === 0">不限时间</span>
            <span
              v-else-if="scope.row.validateType === 1 || scope.row.validateType === 2"
            >{{scope.row.validateStartDateFormat}}至{{scope.row.validateEndDateFormat}}</span>
          </template>
        </el-table-column>-->
        <!-- <el-table-column header-align="center"
                         align="center"
                         label="计费方式">
          <template slot-scope="scope">{{scope.row.chargeType === 0 ? '按次计费' : '按时计费'}}</template>
        </el-table-column>-->
        <el-table-column header-align="center" align="center" label="项目状态">
          <template slot-scope="scope">
            {{ scope.row.status === 0 ? "关闭" : "开启" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所属分类"
          prop="serviceCategoryName"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="所属门店">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
               
              :content="scope.row.storeOutlet"
              placement="top"
            >
              <span>{{ scope.row.storeOutlet }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" label="提醒时间">
          <template slot-scope="scope">
            {{
              scope.row.isRemind === 0
                ? "不提醒"
                : scope.row.isRemind + "小时前"
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="maxEndTime"
          label="预约提前天数"
        >
          <template slot-scope="scope"
            >{{ scope.row.maxEndTime }}天</template
          >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="preOrderTime"
          label="提前预约时间"
        >
          <template slot-scope="scope">
            {{
              scope.row.preOrderTime === 0
                ? "不限制"
                : scope.row.preOrderTime + "小时"
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverTime"
          label="项目间隔"
        >
          <template slot-scope="scope"
            >{{ scope.row.serverTime }}分</template
          >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="copy(scope.row)"
              >复制</el-button
            >
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="serviceList.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <!-- <el-button title="新增项目" :visible.sync="dialogFormVisible" @close="resetForm('ruleForm')">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="项目名称：" prop="name">
          <el-input size="small" v-model.trim="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="计费方式：">
          <el-radio-group v-model="ruleForm.chargeType">
            <el-radio :label="0">按次计费</el-radio>
            <el-radio :label="1">按时计费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目状态：">
          <div class="flex item-center">
            <el-switch
              style="display: block"
              v-model="ruleForm.status"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <span class="form-tip">（关闭后，不出现在小程序项目列表内）</span>
          </div>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')">提交</el-button>
          <el-button size="small" @click="resetForm('ruleForm')">返回</el-button>
        </div>
      </el-form>
    </el-button>-->
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import HmStep from "@/components/HmStep";

export default {
  components: { HmStep },
  data() {
    return {
      steps: [
        {
          link: "StoreList",
          name: "门店列表"
        },
        {
          link: "ServiceCategory",
          name: "服务分类列表"
        },
        {
          link: "ServiceList",
          name: "项目列表"
        },
        {
          link: "StaffList",
          name: "技师列表"
        }
      ],
      name: "",
      pageSize: 10,
      mode: "",
      chargeType: "",
      currentPage: 1,
      dialogFormVisible: false,
      storeOutletId: "",
      serviceCategoryId: "",
      ruleForm: {
        name: "",
        chargeType: 0,
        storeOutletId: "",
        status: 1
      },
      rules: {
        storeOutletId: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        name: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          { max: 15, message: "长度应小于15个字", trigger: "blur" }
        ]
      }
    };
  },
  computed: mapGetters(["serviceList", "storeList", "serviceCategoryList"]),
  watch: {},
  mounted() {
    this.queryList();
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
    this.$store.dispatch("queryServiceCategoryList", {
      pageSize: 999
    });
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryServiceList", {
        name: this.name,
        chargeType: this.chargeType,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeOutletId: this.storeOutletId,
        serviceCategoryId: this.serviceCategoryId
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toAddService() {
      this.$router.push({
        name: "AddService"
      });
      // this.mode = "add";
      // this.dialogFormVisible = true;
      // this.$store.dispatch("queryStoreList", { pageSize: 999 });
    },
    // submitForm(formName) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       let actionName;
    //       let params = this.ruleForm;
    //       if (this.mode === "add") {
    //         actionName = "addService";
    //       } else if (this.mode === "edit") {
    //         actionName = "editService";
    //         params = Object.assign(this.ruleForm, { id: this.currentRowId });
    //       }
    //       this.$store.dispatch(actionName, params).then(res => {
    //         if (res.code === "0") {
    //           this.$message({
    //             message: "操作成功！",
    //             type: "success"
    //           });
    //           this.resetForm(formName);
    //           this.queryList();
    //         }
    //       });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    edit(row) {
      this.$router.push({ name: "EditService", query: { id: row.id } });
      // this.dialogFormVisible = true;
      // this.currentRowId = row.id;
      // this.mode = "edit";
      // for (let key in row) {
      //   if (this.ruleForm.hasOwnProperty(key)) {
      //     this.ruleForm[key] = row[key];
      //   }
      // }
    },

    copy(row) {
      this.$router.push({ name: "CopyService", query: { id: row.id } });
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("deleteService", { id }).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "删除项目成功！",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    }
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    //   for (let key in this.ruleForm) {
    //     this.ruleForm[key] = "";
    //   }
    //   this.ruleForm.chargeType = 0;
    //   this.ruleForm.status = 1;
    //   this.dialogFormVisible = false;
    // }
  }
};
</script>

<style scoped lang="scss">
.tag {
  background-color: #fce6f0;
  padding: 2px 4px;
  margin-right: 5px;
  border-radius: 3px;
  color: #666;
  word-break: keep-all;
}
</style>
